import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
import * as moment from 'moment';

@Component({
    selector: 'dataExport',
    templateUrl: './dataExport.html',
})
export class DataExportComponent extends PageBase {

    constructor(el: ElementRef) {
        super(el, "Order");
        this.updateParams();
    }

    private _from: moment.Moment = this.now.clone();
    private _to: moment.Moment = this.now.clone();
    public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };

    public get from(): moment.Moment { return this._from; }
    public set from(val: moment.Moment) {
        if (this._from != val) {
            this._from = val;
            this.updateParams();
        }
    }

    public get to(): moment.Moment { return this._to; }
    public set to(val: moment.Moment) {
        if (this._to != val) {
            this._to = val;
            this.updateParams();
        }
    }

    public updateParams() {
        this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), pricelist: "ST1" };
    }
}
